'use client';

import { useContext } from 'react';
import ModalContext from '~/context/vdp/ModalContext';
import useTrackAdobeModalEvent from '~/hooks/dealership/useTrackAdobeModalEvent';

export default function DealershipTracking() {
  const { isFeaturesAndSpecsModalOpen } = useContext(ModalContext);

  useTrackAdobeModalEvent(isFeaturesAndSpecsModalOpen, 'features-and-specs');

  return null;
}
